import { Signal } from "@lit-labs/signals";
import type { INotificationsState, Notification, ChatNotification } from "./types";

export class NotificationsState implements INotificationsState {
  readonly notifications = new Signal.State<Notification[]>([]);
  readonly loading = new Signal.State<boolean>(false);
  readonly unreadCount = new Signal.State<number>(0);
  readonly chatNotifications = new Signal.State<ChatNotification[]>([]);
}
